
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('md')) {
        this.initAnimation()
      }
    })
  },
  methods: {
    // old
    // initAnimation() {
    //   this.$gsap.set('.licensing-scroll .text', {
    //     opacity: 0.5,
    //   })
    //   this.$gsap.set(this.$refs.phoneBg, {
    //     scale: 1.1,
    //   })

    //   const panels = this.$gsap.utils.toArray('.panel')
    //   const texts = this.$gsap.utils.toArray('.licensing-scroll .text')

    //   const brochureTl = this.$gsap
    //     .timeline({
    //       paused: true,
    //     })
    //     .from(
    //       '.large-brackets',
    //       {
    //         opacity: 0,
    //       },
    //       '<'
    //     )
    //     .to(
    //       ['.top-left', '.bottom-left'],
    //       {
    //         x: 8,
    //         duration: 0.2,
    //       },
    //       '<+=.1'
    //     )
    //     .to(
    //       ['.top-right', '.bottom-right'],
    //       {
    //         x: -8,
    //         duration: 0.2,
    //       },
    //       '<'
    //     )
    //     .to(
    //       ['.top-left', '.bottom-left', '.top-right', '.bottom-right'],
    //       {
    //         x: 0,
    //         duration: 0.2,
    //       },
    //       '>'
    //     )
    //     .from(['.corner-icon', '.small-brackets'], {
    //       opacity: 0,
    //       duration: 1,
    //     })
    //     .from('.first-panel', {
    //       opacity: 0,
    //       duration: 0.1,
    //     })

    //     .from(panels[0], {
    //       yPercent: 100,
    //       opacity: 0,
    //     })
    //     .from(panels[1], {
    //       yPercent: 100,
    //       opacity: 0,
    //     })
    //     .to(this.$refs.phoneBg, {
    //       scale: 1,
    //     })
    //     .from(this.$refs.phoneNav, {
    //       opacity: 0,
    //       duration: 0.5,
    //     })

    //   const tl = this.$gsap
    //     .timeline({
    //       scrollTrigger: {
    //         trigger: this.$refs.container,
    //         // markers: true,
    //         // pin: true,
    //         scrub: 0.5,
    //         anticipatePin: 1,
    //         start: 'center top+=40%',
    //         end: '+=500%',
    //         onUpdate(self) {
    //           if (self.progress > 0.7) {
    //             brochureTl.play()
    //           }
    //         },
    //         onLeaveBack() {
    //           brochureTl.restart().pause()
    //         },
    //         // onEnterBack() {
    //         //   console.log('enterBack')
    //         //   brochureTl.reverse()
    //         // },
    //       },
    //     })
    //     .from(
    //       this.$refs.phone,
    //       {
    //         y: 600,
    //         duration: 0.5,
    //       },
    //       '<'
    //     )
    //     .to(
    //       '.text-column',
    //       {
    //         y: -450,
    //         duration: 0.5,
    //       },
    //       '<'
    //     )
    //     .from(
    //       this.$refs.brochure,
    //       {
    //         y: -80,
    //         duration: 0.5,
    //       },
    //       '<'
    //     )
    //     .from(
    //       '.first-slide-anim',
    //       {
    //         y: -400,
    //         duration: 0.5,
    //       },
    //       '<'
    //     )
    //     .to(this.$refs.brochure, {
    //       opacity: 0,
    //       duration: 0.8,
    //     })
    //     // .to(this.$refs.brochure, {
    //     //   opacity: 0,
    //     //   duration: 0.8,
    //     // })
    //     // .from(
    //     //   '.large-brackets',
    //     //   {
    //     //     opacity: 0,
    //     //   },
    //     //   '<'
    //     // )
    //     // .to(
    //     //   ['.top-left', '.bottom-left'],
    //     //   {
    //     //     x: 8,
    //     //     duration: 0.2,
    //     //   },
    //     //   '<+=.1'
    //     // )
    //     // .to(
    //     //   ['.top-right', '.bottom-right'],
    //     //   {
    //     //     x: -8,
    //     //     duration: 0.2,
    //     //   },
    //     //   '<'
    //     // )
    //     // .to(
    //     //   ['.top-left', '.bottom-left', '.top-right', '.bottom-right'],
    //     //   {
    //     //     x: 0,
    //     //     duration: 0.2,
    //     //   },
    //     //   '>'
    //     // )
    //     // .from(['.corner-icon', '.small-brackets'], {
    //     //   opacity: 0,
    //     //   duration: 1,
    //     // })
    //     // .from('.first-panel', {
    //     //   opacity: 0,
    //     //   duration: 0.1,
    //     // })
    //     .from(
    //       this.$refs.phone,
    //       {
    //         opacity: 0,
    //         duration: 0.2,
    //       },
    //       0
    //     )

    //   // slide panel up
    //   // panels.forEach((panel, i) => {
    //   //   if (i === 0) return
    //   //   tl.from(panel, {
    //   //     yPercent: 100,
    //   //     opacity: 0,
    //   //     // zIndex: i,
    //   //   })
    //   // })

    //   // final animations
    //   // tl.to(this.$refs.phoneBg, {
    //   //   scale: 1,
    //   // }).from(this.$refs.phoneNav, {
    //   //   opacity: 0,
    //   //   duration: 0.5,
    //   // })

    //   // text fade
    //   texts.forEach((text, i) => {
    //     const tlText = this.$gsap.timeline({
    //       scrollTrigger: {
    //         trigger: text,
    //         start: 'center 70%',
    //         end: 'center 5%',
    //         scrub: true,
    //         // markers: true,
    //         toggleActions: 'play reverse play reverse',
    //       },
    //     })
    //     tlText.to(text, {
    //       opacity: 1,
    //       duration: 2,
    //     })

    //     if (i !== 2) {
    //       tlText.to(text, { opacity: 0.2, duration: 2 }, 2)
    //     }
    //   })
    // },

    initAnimation() {
      this.$gsap.set('.licensing-scroll .text', {
        opacity: 0.5,
      })
      this.$gsap.set(this.$refs.phoneBg, {
        scale: 1.1,
      })

      const panels = this.$gsap.utils.toArray('.panel')
      const texts = this.$gsap.utils.toArray('.licensing-scroll .text')

      const brochureTl = this.$gsap
        .timeline({
          paused: true,
        })
        .from(
          '.large-brackets',
          {
            opacity: 0,
          },
          '<'
        )
        .to(
          ['.top-left', '.bottom-left'],
          {
            x: 8,
            duration: 0.2,
          },
          '<+=.1'
        )
        .to(
          ['.top-right', '.bottom-right'],
          {
            x: -8,
            duration: 0.2,
          },
          '<'
        )
        .to(
          ['.top-left', '.bottom-left', '.top-right', '.bottom-right'],
          {
            x: 0,
            duration: 0.2,
          },
          '>'
        )
        .from(['.corner-icon', '.small-brackets'], {
          opacity: 0,
          duration: 1,
        })
        .from('.first-panel', {
          opacity: 0,
          duration: 0.1,
        })

        .from(panels[0], {
          yPercent: 100,
          opacity: 0,
        })
        .from(panels[1], {
          yPercent: 100,
          opacity: 0,
        })
        .to(this.$refs.phoneBg, {
          scale: 1,
        })
        .from(this.$refs.phoneNav, {
          opacity: 0,
          duration: 0.5,
        })

      this.$gsap
        .timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // markers: true,
            // pin: true,
            scrub: 0.5,
            anticipatePin: 1,
            start: 'center top+=40%',
            end: 'center',
            // end: '+=100%',
            onUpdate(self) {
              if (self.progress > 0.7) {
                brochureTl.play()
              }
            },
            // onLeaveBack() {
            //   brochureTl.restart().pause()
            // },
            onEnter() {
              brochureTl.play()
            },
          },
        })
        .from(this.$refs.qrCode, {
          y: 100,
          duration: 0.5,
        })
        .from(
          '.first-slide-anim',
          {
            y: -50,
            duration: 0.5,
          },
          '<'
        )
      // .from(
      //   this.$refs.phone,
      //   {
      //     y: 600,
      //     duration: 0.5,
      //   },
      //   '<'
      // )
      // .to(
      //   '.text-column',
      //   {
      //     y: -450,
      //     duration: 0.5,
      //   },
      //   '<'
      // )
      // .from(
      //   this.$refs.brochure,
      //   {
      //     y: -80,
      //     duration: 0.5,
      //   },
      //   '<'
      // )
      // .from(
      //   '.first-slide-anim',
      //   {
      //     y: -400,
      //     duration: 0.5,
      //   },
      //   '<'
      // )
      // .to(this.$refs.brochure, {
      //   opacity: 0,
      //   duration: 0.8,
      // })
      // .to(this.$refs.brochure, {
      //   opacity: 0,
      //   duration: 0.8,
      // })
      // .from(
      //   '.large-brackets',
      //   {
      //     opacity: 0,
      //   },
      //   '<'
      // )
      // .to(
      //   ['.top-left', '.bottom-left'],
      //   {
      //     x: 8,
      //     duration: 0.2,
      //   },
      //   '<+=.1'
      // )
      // .to(
      //   ['.top-right', '.bottom-right'],
      //   {
      //     x: -8,
      //     duration: 0.2,
      //   },
      //   '<'
      // )
      // .to(
      //   ['.top-left', '.bottom-left', '.top-right', '.bottom-right'],
      //   {
      //     x: 0,
      //     duration: 0.2,
      //   },
      //   '>'
      // )
      // .from(['.corner-icon', '.small-brackets'], {
      //   opacity: 0,
      //   duration: 1,
      // })
      // .from('.first-panel', {
      //   opacity: 0,
      //   duration: 0.1,
      // })
      // .from(
      //   this.$refs.phone,
      //   {
      //     opacity: 0,
      //     duration: 0.2,
      //   },
      //   0
      // )

      // slide panel up
      // panels.forEach((panel, i) => {
      //   if (i === 0) return
      //   tl.from(panel, {
      //     yPercent: 100,
      //     opacity: 0,
      //     // zIndex: i,
      //   })
      // })

      // final animations
      // tl.to(this.$refs.phoneBg, {
      //   scale: 1,
      // }).from(this.$refs.phoneNav, {
      //   opacity: 0,
      //   duration: 0.5,
      // })

      // text fade

      if (this.$matchMedia('sm')) {
        texts.forEach((text, i) => {
          const tlText = this.$gsap.timeline({
            scrollTrigger: {
              trigger: text,
              start: 'center 70%',
              end: 'center 5%',
              scrub: true,
              // markers: true,
              toggleActions: 'play reverse play reverse',
            },
          })
          tlText.to(text, {
            opacity: 1,
            duration: 2,
          })

          if (i !== 2) {
            tlText.to(text, { opacity: 0.1, duration: 2 }, 2)
          }
        })
      }
    },
    refresh() {
      this.$ScrollTrigger.refresh(true)
    },
  },
}
